export default "__VITE_ASSET__BEMg73nD__"